import {
  Button,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import CronogramaProfessorTablePorDiaSemana from "./CronogramaCurrentProfessorTablePorDiaSemana";
import CronogramaProfessorTableSemanaToda from "./CronogramaCurrentProfessorTableSemanaToda";
import CronogramaCurrentProfessorTableSemanaTodaV2 from "./CronogramaCurrentProfessorTableSemanaTodaV2";

const CronogramaCurrentProfessorContainer = () => {
  const [menu, setMenu] = useState(0);

  return (
    <Container component={Paper}>
      <Grid container direction="row" justifyContent="space-between">
        <Grid>
          <Typography variant="h6">Cronograma</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={3} direction="row">
        <Grid>
          <Button onClick={() => setMenu(0)}>Semanal Versão 2</Button>
        </Grid>
        <Grid>
          <Divider />
        </Grid>
        <Grid>
          <Button onClick={() => setMenu(1)}>Semanal Tabela</Button>
        </Grid>
        <Grid>
          <Button onClick={() => setMenu(2)}>Por Dia da Semana</Button>
        </Grid>

      </Grid>
      {menu === 0 && (
        <CronogramaCurrentProfessorTableSemanaTodaV2 />
      )}
      {menu === 1 && (
        <CronogramaProfessorTableSemanaToda />
      )}
      {menu === 2 && (
        <CronogramaProfessorTablePorDiaSemana />
      )}
    </Container>
  );
};

export default CronogramaCurrentProfessorContainer;
